<template>
  <div
    class="transparent"
    :class="{selected}"
    ref="modalWrap"
    @mousedown.capture="(e) => {
      selected = false;
    }"
    @touchstart.capture="(e) => {
      selected = false;
    }"
  >
    <div
      :style="{ transform: `translate(${x}px, ${y}px)` }"
      ref="window"
      class="window draggable"
      :class="{selected}"
      @mousedown.capture="dragStart"
      @touchstart.capture="dragStart"
    >
      <div class="draggable">
        <span class="draggable" v-text="title"></span>
        <button class="close" @click="close" @touchstart="close">
          <span aria-hidden="true" class="btn-close">&times;</span>
        </button>
      </div>
      <!--
      <audio
        :muted="!config.audio"
        :src="src"
        ref="myAudio"
        controls
        controlslist="nodownload"
        disablepictureinpicture
      />
      -->
      <meAudio
        :src="src"
        :audioid="id"
        :options="{
          audioWidth: 280,
        }"
        :mute="!config.audio"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import meAudio from './meAudio.vue';

export default {
  name: 'AudioModal',
  components: { meAudio },
  props: {
    src: String,
    config: Object,
    title: String,
    id: String,
  },
  data() {
    return {
      initPosition: {
        x: 0,
        y: 0,
      },
      x: 0,
      y: 120,
      dragging: false,
      selected: true,
    };
  },
  created() {
    window.addEventListener('mousemove', this.dragMove, { passive: false });
    window.addEventListener('touchmove', this.dragMove, { passive: false });
    window.addEventListener('mouseup', this.dragEnd, { passive: false });
    window.addEventListener('touchend', this.dragEnd, { passive: false });
  },
  mounted() {
    this.initPosition = { x: 0, y: 0 };

    this.x =
      (this.$refs['modalWrap'].clientWidth - this.$refs['window'].clientWidth) /
      2;
    this.y =
      (this.$refs['modalWrap'].clientHeight -
        this.$refs['window'].clientHeight) /
      2;

    this.$nextTick(() => {
      // this.$refs.myAudio.muted = !this.config.audio;
    });
  },
  beforeDestroy() {
    window.removeEventListener('mousemove', this.dragMove);
    window.removeEventListener('touchmove', this.dragMove);
    window.removeEventListener('mouseup', this.dragEnd);
    window.removeEventListener('touchend', this.dragEnd);
  },
  methods: {
    close() {
      console.log('close');
      this.$emit('closemodal');
    },
    dragStart(e) {
      this.selected = true;
      console.log('dragStart');
      console.log(e.currentTarget);
      console.log(e.target.className);
      if (e.target.className.indexOf('draggable') !== -1) {
        e.preventDefault();
        // e.stopPropagation();
        let point;
        this.dragging = true;
        if (e.touches) {
          point = e.changedTouches[0];
        } else {
          point = e;
        }
        this.initPosition = {
          x: point.pageX - this.x,
          y: point.pageY - this.y,
        };
      } else if (e.target.className.indexOf('btn-close') !== -1) {
        e.preventDefault();
        e.stopPropagation();
        this.close();
      }
    },
    dragMove(e) {
      let point;
      if (this.dragging) {
        e.preventDefault();
        e.stopPropagation();
        if (e.touches) {
          point = e.changedTouches[0];
        } else {
          point = e;
        }

        this.x = point.pageX - this.initPosition.x;
        this.y = point.pageY - this.initPosition.y;
      }
    },
    dragEnd(e) {
      if (this.dragging) {
        e.preventDefault();
        e.stopPropagation();

        this.dragging = false;
        this.selected = true;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.window {
  position: fixed;
  top: 0;
  left: 0;
  background: #eee;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.35);
  z-index: 1025;
  border-radius: 10px;
  padding: 10px;
  width: 300px;
}

.window audio {
  width: 100%;
}

button {
  position: absolute;
  top: 0;
  right: 0;
}

.transparent {
  background: transparent;
  pointer-events: none;

  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1020;
}

.transparent * {
  pointer-events: initial;
}
</style>
